"use client";
import { motion, useScroll, useTransform, useMotionValueEvent } from "framer-motion";
import { useRef, useState } from "react";
import Framerimg1 from "../images/pc-desktop.jpeg";
import Framerimg2 from "../images/akash.png";

export default function ScrollImage() {
  const ref = useRef(null);
  const [currentImage, setCurrentImage] = useState(Framerimg1);

  // Track scroll progress relative to this section
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });

  // Animate transforms
  const y = useTransform(scrollYProgress, [0, 1], [0, 600]);
  const rotateY = useTransform(scrollYProgress, [0, 1], [0, 180]);
  const opacity = useTransform(scrollYProgress, [0, 0.2, 1], [1, 1, 0.8]);

  // Listen for scroll progress updates
  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    if (latest > 0.5) {
      setCurrentImage(Framerimg2);
    } else {
      setCurrentImage(Framerimg1);
    }
  });

  return (
    <div ref={ref}>
      <motion.img
        key={currentImage} // 👈 ensures re-render on src change
        src={currentImage}
        alt="scroll animation"
        className="rounded-2xl shadow-lg backface-hidden"
        style={{ y, rotateY, opacity }}
        width={500}
        height={500}
      />
    </div>
  );
}
